module.exports = __webpack_public_path__ + "img/Optometry.173ebee.png";